import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';

import MainLayout from '../../components/Layout/MainLayout';
import { useAuth } from '../../context/AuthContext';

import {
  PageWrapper,
  CardContainer,
  PageTitle,
  ForgotLink,
  FooterText,
  RegisterLink,
} from './styles';

export default function SignIn() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const history = useHistory();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await login(values.email, values.password);
      history.push('/cuenta');
    } catch {
      message.error('Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    message.info('Se ha enviado un enlace de recuperación a tu correo');
  };

  return (
    <MainLayout showSidebar={false}>
      <PageWrapper>
        <CardContainer>
          <PageTitle>Iniciar Sesión</PageTitle>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Ingresa tu correo electrónico' },
                { type: 'email', message: 'Ingresa un correo válido' },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="Correo electronico"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Ingresa tu contraseña' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Contrasena"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Form.Item name="recordarme" valuePropName="checked" noStyle>
                  <Checkbox>Recordarme</Checkbox>
                </Form.Item>
                <ForgotLink onClick={handleForgotPassword}>
                  ¿Olvidaste tu contraseña?
                </ForgotLink>
              </div>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large" loading={loading}>
                Ingresar
              </Button>
            </Form.Item>
          </Form>

          <FooterText>
            ¿No tienes cuenta?{' '}
            <Link to="/registro">
              <RegisterLink>Regístrate</RegisterLink>
            </Link>
          </FooterText>
        </CardContainer>
      </PageWrapper>
    </MainLayout>
  );
}
